import { render } from "./ChartBars.vue?vue&type=template&id=22964598"
import script from "./ChartBars.vue?vue&type=script&lang=js"
export * from "./ChartBars.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__